export default class CreditBookType {
	static typeSearch = "local"; //online || local
	properties={
		nm : "",
		mp : ""
	}
	constructor(data=null) {
        this.properties.id = (data?.id)?data.id:null
		this.properties.nm = (data?.nom)?data.nm : ""
		this.properties.mp = (data?.mp)?data.mp: []
	}

	static getPropertyModel() {
		const cb = new CreditBookType()
    return cb.properties;
  }

}